import { useMemo as S, useCallback as $ } from "react";
var A = /* @__PURE__ */ ((e) => (e.PAGEVIEW = "pageview", e.CLICK = "click", e))(A || {}), F = /* @__PURE__ */ ((e) => (e.REMOVE_FROM_CART = "remove_from_cart", e.ADD_TO_CART = "add_to_cart", e.MORE_INFO = "more_info", e))(F || {}), V = /* @__PURE__ */ ((e) => (e.NAVIGATION = "navigation", e.FORM = "form", e.ERROR = "error", e.FEATURE = "feature", e.IMPRESSION = "impression", e.SEARCH = "search", e.FILTER = "filter", e.TIME = "time", e.CHATBOT = "chatbot", e.DOWNLOAD = "download", e))(V || {});
const U = [
  "fm",
  "sb"
  // playground
];
function I(e) {
  return U.includes(e) ? "DE" : e.toUpperCase();
}
function _(e) {
  switch (I(e)) {
    case "CH":
      return "CHF";
    case "GB":
      return "GBP";
    case "SE":
      return "SEK";
    default:
      return "EUR";
  }
}
function D(e) {
  return e.slice(0, 2);
}
function G(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var H = function(r) {
  return K(r) && !W(r);
};
function K(e) {
  return !!e && typeof e == "object";
}
function W(e) {
  var r = Object.prototype.toString.call(e);
  return r === "[object RegExp]" || r === "[object Date]" || Y(e);
}
var B = typeof Symbol == "function" && Symbol.for, x = B ? Symbol.for("react.element") : 60103;
function Y(e) {
  return e.$$typeof === x;
}
function q(e) {
  return Array.isArray(e) ? [] : {};
}
function g(e, r) {
  return r.clone !== !1 && r.isMergeableObject(e) ? u(q(e), e, r) : e;
}
function z(e, r, n) {
  return e.concat(r).map(function(c) {
    return g(c, n);
  });
}
function J(e, r) {
  if (!r.customMerge)
    return u;
  var n = r.customMerge(e);
  return typeof n == "function" ? n : u;
}
function Q(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(r) {
    return Object.propertyIsEnumerable.call(e, r);
  }) : [];
}
function R(e) {
  return Object.keys(e).concat(Q(e));
}
function L(e, r) {
  try {
    return r in e;
  } catch {
    return !1;
  }
}
function X(e, r) {
  return L(e, r) && !(Object.hasOwnProperty.call(e, r) && Object.propertyIsEnumerable.call(e, r));
}
function Z(e, r, n) {
  var c = {};
  return n.isMergeableObject(e) && R(e).forEach(function(t) {
    c[t] = g(e[t], n);
  }), R(r).forEach(function(t) {
    X(e, t) || (L(e, t) && n.isMergeableObject(r[t]) ? c[t] = J(t, n)(e[t], r[t], n) : c[t] = g(r[t], n));
  }), c;
}
function u(e, r, n) {
  n = n || {}, n.arrayMerge = n.arrayMerge || z, n.isMergeableObject = n.isMergeableObject || H, n.cloneUnlessOtherwiseSpecified = g;
  var c = Array.isArray(r), t = Array.isArray(e), l = c === t;
  return l ? c ? n.arrayMerge(e, r, n) : Z(e, r, n) : g(r, n);
}
u.all = function(r, n) {
  if (!Array.isArray(r))
    throw new Error("first argument should be an array");
  return r.reduce(function(c, t) {
    return u(c, t, n);
  }, {});
};
var k = u, ee = k;
const P = /* @__PURE__ */ G(ee), oe = (e, r) => r === A.PAGEVIEW ? { page: e } : { eventInfo: e }, re = (e) => {
  const { page: r, ...n } = e, { referringPage: c, ...t } = r;
  return {
    page: {
      ...c ? { referringPage: c } : void 0,
      ...t
    },
    ...n
  };
}, ne = (e) => e.hasOwnProperty("page"), se = (e, r, n) => {
  var C;
  const {
    baseUrl: c,
    featureServices: {
      "endpoint-directory": t,
      "login-service": l,
      "adb-context-service": m,
      "locale-service": d
    }
  } = e(), h = (t == null ? void 0 : t.envName) ?? "stage", { marketId: p, languageTag: E } = (d == null ? void 0 : d.getLocale()) || {}, M = E ? D(E) : "", j = p ? _(p) : "", v = c == null ? void 0 : c.split("/").pop(), T = (C = m == null ? void 0 : m.adbContext) != null && C.hasCustomer ? "ADB" : "web";
  let b, O, y;
  const i = l && "loginState" in l && l.loginState;
  i && "status" in i && "customerType" in i && "uid" in i && i.status === "logged-in" ? (b = i.customerType, O = i.uid, y = "logged_in") : y = "logged_out";
  const w = S(() => {
    const o = window == null ? void 0 : window.adobeDataLayer;
    return o && typeof o == "object" && typeof (o == null ? void 0 : o.push) == "function" ? (a) => {
      "page" in a && console.info(`[Tracking data pushed] for ${a.page} page`), o.push(a);
    } : (a) => {
      if (console.info("[Tracking data pushed]", a), "page" in a) {
        const { page: s, event: f } = a;
        console.info(
          `%c[TRK] ${s.name} ${s.type} ${f}`,
          "color: #0074D9"
        );
      }
      if ("eventInfo" in a) {
        const { eventInfo: s, event: f } = a;
        console.info(`%c[TRK] ${s == null ? void 0 : s.name} ${f}`, "color: #0074D9");
      }
    };
  }, []);
  return $(
    (o, a = A.PAGEVIEW) => {
      let s;
      if (ne(o)) {
        const N = P(o, {
          page: {
            referringPage: n
          }
        });
        s = re(N);
      } else
        s = o;
      const f = P(
        {
          event: a,
          user: {
            loginStatus: y,
            customerId: O,
            type: b ? b === "private" ? "b2c" : "b2b" : void 0,
            channel: T
          },
          application: {
            id: r,
            version: v ?? "",
            env: h,
            language: M,
            market: p ?? "",
            currency: j
          }
        },
        s
      );
      w(f);
    },
    [
      r,
      j,
      w,
      h,
      M,
      p,
      n,
      T,
      v,
      y,
      O,
      b
    ]
  );
};
function te(e) {
  (window.adobeDataLayer = window.adobeDataLayer || []).push(
    e
  );
}
const ce = (e) => {
  if ((e == null ? void 0 : e.status) !== "logged-in")
    return { loginStatus: "logged_out" };
  const { uid: r, customerType: n } = e;
  return {
    loginStatus: "logged_in",
    customerId: r,
    type: n === "private" ? "b2c" : "b2b"
  };
};
function ie(e, r, n, c, t) {
  te({
    event: "click",
    eventInfo: n,
    user: ce(r),
    application: {
      id: "aem",
      version: process.env.VERSION,
      env: e || "dev",
      language: D(c),
      market: I(t).toLowerCase(),
      currency: _(t)
    }
  });
}
export {
  F as EventName,
  V as EventSource,
  A as EventType,
  ne as isPageViewEvents,
  ie as pushClickEvent,
  te as pushToDataLayer,
  re as removeEmptyReferringPage,
  se as useCoreAnalytics,
  oe as wrapEventInfoOrPage
};
//# sourceMappingURL=index.mjs.map
